(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
